// extracted by mini-css-extract-plugin
export var container = "WasteDetailsModal-module--container--fJsG3";
export var content = "WasteDetailsModal-module--content--yr3Tn";
export var footer = "WasteDetailsModal-module--footer--ptNQL";
export var header = "WasteDetailsModal-module--header--ifG8W";
export var wasteDetailCell = "WasteDetailsModal-module--wasteDetailCell--6S-ZQ";